import { render } from "./WCPaymentOptionBadge.vue?vue&type=template&id=bde74342&scoped=true"
import script from "./WCPaymentOptionBadge.vue?vue&type=script&lang=js"
export * from "./WCPaymentOptionBadge.vue?vue&type=script&lang=js"

import "./WCPaymentOptionBadge.vue?vue&type=style&index=0&id=bde74342&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bde74342"]])

export default __exports__